export default (defaultType) => ({
  default: (payload) => ({
    type: defaultType,
    payload,
  }),
  success: (payload) => ({
    type: `${defaultType}_SUCCESS`,
    payload,
  }),
  error: (err) => ({
    type: `${defaultType}_ERROR`,
    error: err,
  }),
  reset: () => ({
    type: `${defaultType}_RESET`,
  }),
});

// eslint-disable-next-line flowtype/no-types-missing-file-annotation
export type ApiActions<Type, Payload> = {
  default: (payload: Payload) => ({
    type: Type,
    payload: Payload,
  }),
  success: (payload: any) => ({
    type: Type & '_SUCCESS',
    payload: any,
  }),
  error: (error: any) => ({
    type: Type & '_ERROR',
    error: any,
  }),
  reset: () => ({
    type: Type & '_RESET',
  }),
}
